(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordeks-guide-article"]) return;
  try {
    
  const guideBody = document.querySelector('[data-nordeks-guide-body]');
  const toc = document.querySelector('[data-nordeks-toc]');
  const tocList = document.querySelector('[data-nordeks-toc-list]');
  const tocToggle = document.querySelector('[data-nordeks-toc-toggle]');

  if (guideBody && toc && tocList) {
    const firstContent = guideBody.firstElementChild;
    if (firstContent && firstContent.tagName === 'P') {
      firstContent.classList.add('ng-lead');
    }

    const iconSets = {
      'lighting-guides': ['⌖', '◉', '⚡', '☀', '◇', '↔', '◫', '✓', '↗', '!', '↗'],
      'portable-work-lighting': ['⌖', '◉', '↔', '◷', '◎', '◆', '◫', '✓', '↗', '!', '↗'],
      'batteries-charging': ['↔', '○', '↻', '⚡', '❄', '÷', '↯', '✓', '↗', '!', '↗']
    };
    const categoryIcons = iconSets[guideBody.dataset.guideCategory] || ['◆', '◉', '↔', '✓', '!', '↗'];

    guideBody.querySelectorAll('h2').forEach((heading, index) => {
      heading.classList.add('ng-heading');
      if (!heading.querySelector('.ng-heading-icon')) {
        const icon = document.createElement('span');
        icon.className = 'ng-heading-icon';
        icon.dataset.icon = categoryIcons[index % categoryIcons.length];
        icon.setAttribute('aria-hidden', 'true');
        heading.prepend(icon);
      }
    });

    const nearestHeading = (element) => {
      let sibling = element.previousElementSibling;
      while (sibling && sibling.tagName !== 'H2') sibling = sibling.previousElementSibling;
      return sibling ? sibling.textContent.trim().toLowerCase() : '';
    };

    guideBody.querySelectorAll(':scope > ul').forEach((list) => {
      const headingText = nearestHeading(list);
      if (/official|ametlik/.test(headingText)) {
        list.classList.add('ng-source-grid');
      } else if (list.children.length <= 4) {
        list.classList.add('ng-check-grid');
      }
    });

    guideBody.querySelectorAll(':scope > ol').forEach((list) => list.classList.add('ng-step-list'));

    guideBody.querySelectorAll(':scope > p').forEach((paragraph) => {
      const text = paragraph.textContent.trim();
      if (/^(Practical rule|Praktiline reegel):/i.test(text)) paragraph.classList.add('ng-callout');
      if ((text.includes('=') || text.includes('÷')) && paragraph.querySelector('strong')) {
        paragraph.classList.add('ng-formula');
      }
    });

    const wrapSection = (heading, className) => {
      if (!heading || heading.nextElementSibling?.classList.contains(className)) return;
      const wrapper = document.createElement('div');
      wrapper.className = className;
      heading.after(wrapper);
      let next = wrapper.nextElementSibling;
      while (next && next.tagName !== 'H2') {
        const following = next.nextElementSibling;
        wrapper.append(next);
        next = following;
      }
    };

    guideBody.querySelectorAll(':scope > h2').forEach((heading) => {
      const text = heading.textContent.trim().toLowerCase();
      if (/safety|ohutus|charging and safety|laadimine ja ohutus/.test(text)) {
        wrapSection(heading, 'ng-callout');
      } else if (/useful nordeks|kasulikud nordeksi|current nordeks examples|nordeksi praegused|two current nordeks|kaks nordeksi|kaks praegust näidet nordeksi|praegused näited nordeksi/.test(text)) {
        wrapSection(heading, 'ng-panel');
      }
    });

    const headings = [...guideBody.querySelectorAll('h2, h3')];

    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');
        heading.id = base || `section-${index + 1}`;
      }

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.append(link);
      tocList.append(item);
    });

    if (headings.length > 1) {
      toc.hidden = false;
    }

    guideBody.querySelectorAll('table').forEach((table) => {
      table.classList.add('ng-table');
      if (!table.parentElement.classList.contains('ng-table-scroll')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'ng-table-scroll';
        table.before(wrapper);
        wrapper.append(table);
      }

      const labels = [...table.querySelectorAll('thead th')].map((header) => header.textContent.trim());

      if (!labels.length) return;

      table.dataset.mobileCards = 'true';
      table.querySelectorAll('tbody tr').forEach((row) => {
        [...row.children].forEach((cell, index) => {
          cell.dataset.label = labels[index] || '';
        });
      });
    });
  }

  if (toc && tocToggle) {
    tocToggle.addEventListener('click', () => {
      const isOpen = toc.classList.toggle('is-open');
      tocToggle.setAttribute('aria-expanded', String(isOpen));
      tocToggle.lastElementChild.textContent = isOpen ? '−' : '+';
    });
  }

  } catch(e) { console.error(e); }
})();
})();
